import { useSession } from "@outschool/ui-auth";
import React from "react";

import { useBannerDismissal } from "../../hooks/useBannerDismissal";
import ArtShowcaseBanner from "./ArtShowcaseBanner";
import MembershipsBannerSwitcher, {
  useShouldShowMembershipBannerByPath,
} from "./MembershipsBannerSwitcher";

/**
 * Gate on top of the MembershipsBannerSwitcher to short-circuit the banner rendering for logged-out users.
 * This helps prevent layout shift and excessive network requests for logged-out users, who can never see the
 * other banners that MembershipsBannerSwitcher renders. This component duplicates some logic from
 * MembershipsBannerSwitcher, so update both if you change the logic here.
 */
export default function MembershipsBannerGate() {
  const { isLoggedIn, currentUserIsLoading, currentUser } = useSession();
  const { shouldShowBannersToday } = useBannerDismissal();
  const shouldShowBannerByPath = useShouldShowMembershipBannerByPath();

  // Gate everything until the user is loaded
  if (currentUserIsLoading) {
    return null;
  }

  if (!isLoggedIn) {
    if (shouldShowBannersToday && shouldShowBannerByPath) {
      return <ArtShowcaseBanner />;
    }

    return null;
  }

  return <MembershipsBannerSwitcher currentUser={currentUser} />;
}
